export const SOFTLINE_API_ITEM = '/v1/items/entities';
export const SOFTLINE_API_ITEM_PRICE = '/v1/items/price';
export const SOFTLINE_API_ITEM_DETAIL = '/v1/items/detail';
export const SOFTLINE_API_ITEM_STOCK = '/v1/items/stock';
export const SOFTLINE_API_ITEM_ATTRIBUTE = '/v1/items/attributes/entities';
export const SOFTLINE_API_MEDIA = '/v1/items/image/';
export const SOFTLINE_API_FAVORITES = '/v1/items/favorites/entities';
